import React, { createContext, useContext, useEffect, useState } from "react";
import { getCurrency } from "../utils/indexedDBUtils";
interface CurrencyContextType {
  isDollar: boolean;
  setIsDollar: (isDollar: boolean) => void;
}

const CurrencyContext = createContext<CurrencyContextType | undefined>(undefined);

export const CurrencyProvider: React.FC<React.PropsWithChildren> = ({
  children,
}) => {
  const [isDollar, setIsDollar] = useState<boolean>(false);

  const fetchCurrency = async () => {
    const value = await getCurrency();
    setIsDollar(value);
  };

  useEffect(() => {
    fetchCurrency();

    const onCurrencyChange = () => {
      fetchCurrency();
    };

    window.addEventListener("currencyChanged", onCurrencyChange);
    return () => {
      window.removeEventListener("currencyChanged", onCurrencyChange);
    };
  }, []);
  return (
    <CurrencyContext.Provider
      value={{
        isDollar,
        setIsDollar,
      }}
    >
      {children}
    </CurrencyContext.Provider>
  );
};

export const useCurrency = () => {
  const context = useContext(CurrencyContext);
  if (context === undefined) {
    throw new Error("useCurrency must be used within an CurrencyProvider");
  }
  return context;
};
